import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';

// constants
import routes from '../../constants/routes';

import { MessageContentContext } from '../../context/EditorContext';

import FormulaCreateMainV2 from '../formulaCreate/FormulaCreateMainV2';
import FormulaViewMainV2 from '../formulaView/FormulaViewMain';
// components
import FormulasCatalogMain from './FormulasCatalogMain';
import MessagesMain from './MessagesMain/MessagesMain';

const FormulasMain: React.FC<React.PropsWithChildren<unknown>> = () => {
    const [isContentUpdating, setIsContentUpdating] = useState<boolean>(false);

    return (
        <MessageContentContext.Provider
            value={{
                isContentUpdating,
                setIsContentUpdating,
            }}
        >
            <Switch>
                <Route
                    path={[
                        routes.formulaDraft(':formulaId'),
                        routes.formulasCreate,
                    ]}
                    component={FormulaCreateMainV2}
                />
                <Route
                    path={routes.formulaView(':status', ':formulaId')}
                    component={FormulaViewMainV2}
                />
                <Route
                    path={routes.formulasCatalogWithTabs(':status')}
                    component={FormulasCatalogMain}
                />
                <Route path={routes.formulasMain} component={MessagesMain} />
            </Switch>
        </MessageContentContext.Provider>
    );
};

export default FormulasMain;
